import { Link, useNavigate } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";
import { ChevronRight } from "lucide-react";
import { track } from "@/lib/track";
import { startViewTransition } from "@/lib/view-transition";
import { useLocalizedHref } from "@/hooks/useLocalizedHref";
import * as React from "react";

export function CaseStudyCTA() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const localizedHref = useLocalizedHref();

  const goToFit = (e: React.MouseEvent<HTMLAnchorElement>) => {
    track("fit_click", { source: "case_study" });
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
    e.preventDefault();
    startViewTransition(async () => {
      await navigate({ to: localizedHref("/fit") });
    });
  };

  return (
    <section className="mt-24 lg:mt-32">
      <div className="flex flex-col gap-8 rounded-[22px] border border-line bg-surface p-10 lg:flex-row lg:items-center lg:justify-between lg:p-14">
        <div>
          <span className="eyebrow">
            <span className="num">—</span> {t("work.cta.eyebrow")}
          </span>
          <h2 className="mt-3 text-[clamp(28px,3.6vw,40px)] leading-[1.1] font-medium tracking-[-0.025em] text-ink">
            <Trans
              i18nKey="work.cta.title"
              components={{
                italic: <span className="serif-italic text-accent" />,
              }}
            />
          </h2>
          <p className="mt-3 max-w-[48ch] text-[15px] leading-[1.55] text-ink-2">
            {t("work.cta.lede")}
          </p>
        </div>
        <Link
          to={localizedHref("/fit")}
          onClick={goToFit}
          className="btn-orange shrink-0 self-start lg:self-auto"
        >
          {t("work.cta.button")}
          <span className="pip">
            <ChevronRight className="h-4 w-4" strokeWidth={2.5} />
          </span>
        </Link>
      </div>
    </section>
  );
}
